import { Integration } from "../integrations/integration";
import { Workspace } from "../workspace/workspace";
import { CodeIntegrationDump } from "./code-integration-dump";
import { DesignSystemDump } from "./design-system-dump";
import { z } from "zod";
export const WorkspaceDump = z.object({
    workspace: Workspace,
    designSystems: DesignSystemDump.array(),
    codeIntegration: CodeIntegrationDump,
    integrations: Integration.array(),
});
